import {
  Box,
  Button,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CustomPopup from "../../../components/CustomPopup";
import AdminAllMonthDetails from "./AdminAllMonthDetails";
import StyledTableContainer from "../../../newTestPrep/newComponent/TableContainer";
import { useGetTokenOrLogout } from "../../../utils/token";
import EnrollDetails from "../popupComponent/EnrollDetails";
import MoreCardDetails from "../popupComponent/MoreCardDetails";
import CustomSnackbar from "../../../newTestPrep/components/ui-component/snackbar/CustomSnackbar";
import LoaderComp from "../../../newTestPrep/newComponent/LoaderComp/Loader";
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export default function AdminDetailsStat({
  data,
  isPopup,
  choosenYear,
  selectedFilter,
  fromDate,
  toDate,
  countryId
}) {
  const getTokenOrLogout = useGetTokenOrLogout();

  const userId = localStorage.getItem("userId");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(12);
  const [openPopup, setOpenPopup] = useState(false);
  const [opendetailPopup, setOpenDetailPopup] = useState(false);
  const [selectedData, setselectedData] = useState([]);
  const [selectedDataName, setSelectedDataname] = useState(null);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [selectedFilterType, setSelectedFilterType] = useState(null);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [rowData, setRowData] = useState(null);
  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleOpenPopup = () => {
    setOpenPopup(true);
  };

  const handleClosePopup = () => {
    setOpenPopup(false);
  };

  // detailPopup
  const handleOpenDetailPopup = (Name, rowData, filterType) => {
    setOpenDetailPopup(true);
    setSelectedDataname(Name);
    setRowData(rowData);
    setSelectedFilterType(filterType);
  };

  const handleCloseDetailPopup = () => {
    setOpenDetailPopup(false);
  };

  const getCardMoreInfo = async (cardName, rowData, filterType) => {
    setDetailsLoading(true);
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    const requestData = {
      user_id: parseInt(userId),
      month: rowData?.month_full_name,
      year: choosenYear,
      filter_type: filterType,
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}admindashboard/fetch-monthly-detailed-data`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );
      const result = await response.json();
      if (response.ok) {
        setselectedData(result);
        setDetailsLoading(false);
        handleOpenDetailPopup(cardName, rowData, filterType);
      } else if (response.status === 400) {
        showSnackbar(result.message, "error");
        setDetailsLoading(false);
      } else if (response.status === 401) {
        showSnackbar(result.message, "error");
        setDetailsLoading(false);
      } else if (response.status === 403) {
        showSnackbar(result.message, "error");
        setDetailsLoading(false);
      } else if (response.status === 405) {
        showSnackbar(result.message, "error");
        setDetailsLoading(false);
      } else {
        showSnackbar("Server Error", "error");
        setDetailsLoading(false);
      }
    } catch (error) {
      showSnackbar("Server Error", "error");
      setDetailsLoading(false);
    }
  };

  return (
    <>
      <LoaderComp isLoading={detailsLoading} />
      <Box>
        <StyledTableContainer component={Paper}>
          <Table style={{ background: "#F9F9F9" }}>
            <TableHead>
              <TableRow>
                <TableCell>Month Name</TableCell>
                <TableCell>STM Enrolment</TableCell>
                <TableCell>Online Enrolment</TableCell>
                <TableCell>Offline Enrolment</TableCell>
                <TableCell>SAP Enrolment</TableCell>
                <TableCell>Total Revenue</TableCell>
                <TableCell>Collected</TableCell>
                <TableCell>Pending</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.length === 0 ? (
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  mt={2}
                >
                  <Typography
                    sx={{
                      fontFamily: "Roboto",
                      fontSize: "11px",
                      color: "#000000",
                    }}
                  >
                    No data available
                  </Typography>
                </Box>
              ) : (
                data
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => (
                    <TableRow
                      key={index}
                      style={{
                        width: "6%",
                      }}
                    >
                      <TableCell>{row?.month_short_name}</TableCell>
                      <TableCell
                        style={{ cursor: "pointer", color: "blue" }}
                        onClick={() =>
                          getCardMoreInfo(
                            "Total Enrolments",
                            row,
                            "total_enrolment"
                          )
                        }
                      >
                        {row?.total_enrollment}
                      </TableCell>
                      <TableCell
                        style={{ cursor: "pointer", color: "blue" }}
                        onClick={() =>
                          getCardMoreInfo(
                            "Online Enrollments",
                            row,
                            "online_enrolment"
                          )
                        }
                      >
                        {row?.online_enrollment}
                      </TableCell>
                      <TableCell
                        style={{ cursor: "pointer", color: "blue" }}
                        onClick={() =>
                          getCardMoreInfo(
                            "Offline Enrollments",
                            row,
                            "offline_enrolment"
                          )
                        }
                      >
                        {row?.offline_enrollment}
                      </TableCell>
                       <TableCell
                        style={{ cursor: "pointer", color: "blue" }}
                        onClick={() =>
                          getCardMoreInfo(
                            "SAP Enrollment",
                            row,
                            "sap_enrollment"
                          )
                        }
                      >
                        {row?.sap_enrollment}
                      </TableCell>
                      <TableCell
                        style={{ cursor: "pointer", color: "blue" }}
                        onClick={() =>
                          getCardMoreInfo("Total Revenue", row, "total_revenue")
                        }
                      >
                        {row?.total_revenue}
                      </TableCell>
                      <TableCell
                        style={{ cursor: "pointer", color: "blue" }}
                        onClick={() =>
                          getCardMoreInfo(
                            "Collected Revenue",
                            row,
                            "collected_revenue"
                          )
                        }
                      >
                        {row?.collected_revenue}
                      </TableCell>
                      <TableCell
                        style={{ cursor: "pointer", color: "blue" }}
                        onClick={() =>
                          getCardMoreInfo(
                            "Pending Revenue",
                            row,
                            "pending_revenue"
                          )
                        }
                      >
                        {row?.pending_revenue}
                      </TableCell>
                    </TableRow>
                  ))
              )}
            </TableBody>
          </Table>
        </StyledTableContainer>

        {/* {data.length > 9 && !isPopup && (
          <Box sx={{ textAlign: "center" }}>
          
              <Button
                style={{
                  fontSize: "12px",
                  fontWeight: 400,
                  fontFamily: "Roboto",
                  color: "#00B13F",
                  textAlign: "center",
                }}
                onClick={handleOpenPopup}
              >
                Show All Month
              </Button>
           
          </Box>
        )} */}
      </Box>

      <CustomPopup
        open={openPopup}
        onClose={handleClosePopup}
        component={
          <AdminAllMonthDetails
            onClose={handleClosePopup}
            data={data}
            choosenYear={choosenYear}
          />
        }
        maxWidth="md"
        showDivider={false}
      />

      <CustomPopup
        open={opendetailPopup}
        onClose={handleCloseDetailPopup}
        component={
          selectedFilterType === "online_enrolment" ||
          selectedFilterType === "offline_enrolment" ||
          selectedFilterType === "total_enrolment" ? (
            <EnrollDetails
              onClose={handleCloseDetailPopup}
              selectedFilter="default"
              SelectedCardData={selectedData}
              monthName={rowData?.month_full_name}
              selectedYear={choosenYear}
            />
          ) : (
            <MoreCardDetails
              onClose={handleCloseDetailPopup}
              selectedFilter="default"
              SelectedCardData={selectedData}
              selectedCardName={selectedDataName}
              selectedCountFilter={selectedFilterType}
              monthName={rowData?.month_full_name}
              selectedYear={choosenYear}
              countryId={countryId}
            />
          )
        }
        title={`${selectedDataName} Details`}
        maxWidth="lg"
        showDivider={true}
      />

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
}
